export enum HistoricalVolatilityPriceType {
    Last,
    BidAsk,
    OHLC,
    OHL
}
